/** The Vortex mark — two orbital arcs about a still centre. */
export function Mark({ title }: { title?: string }) {
  return (
    <svg viewBox="0 0 64 64" aria-hidden={title ? undefined : true} role={title ? 'img' : undefined}>
      {title ? <title>{title}</title> : null}
      <g fill="none" stroke="#e43024" strokeLinecap="round">
        <circle cx="32" cy="32" r="23" strokeWidth="6" strokeDasharray="108 37" transform="rotate(-30 32 32)" />
        <circle cx="32" cy="32" r="13" strokeWidth="6" strokeDasharray="61 21" transform="rotate(70 32 32)" />
      </g>
      <circle cx="32" cy="32" r="5" fill="currentColor" />
    </svg>
  );
}
